module.exports = "https://cdn.realtymogul.com/static/media/bell_white.19645a91.svg";